import { render, staticRenderFns } from "./CustomerDashboardView.vue?vue&type=template&id=4544c522"
import script from "./CustomerDashboardView.vue?vue&type=script&lang=js"
export * from "./CustomerDashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports